
export default{
  computed: {
    budgetPostText () {
      var booking = this.booking
      if (this.thread && this.thread.booking) {
        booking = this.thread.booking
      }

      var postText = ''
      if (this.$userIsManager) {
        postText += ` /${this.$starLabel}`
      }
      if (this.$userIsClient) {
        postText += ` /${this.$starLabel}`
        if (this.$showTax) {
          postText += ` (+${this.clientName === 'GSE' ? 'tax' : 'GST'})`
        }
      }

      if (this.$userIsAdmin) {
        if (this.monetaryCurrency) {
          postText += ` ($${booking.budget_per_star_as_user_rate}) /${this.$starLabel}`
          if (this.$showTax) {
            postText += ` (+${this.clientName === 'GSE' ? 'tax' : 'GST'})`
          }
        } else if (!booking.currency === 'points') {
          postText += ` (${booking.budget_per_star_as_user_rate}) /${this.$starLabel}`
        }
      }
      if (booking.budget_not_confirmed) {
        postText += '(not-confirmed)'
      }
      return postText
    }
  }
}
